var initialState = {
}

export function preApp(state = initialState, action) {
	switch (action.type) {
		default:
			return state
	}
}